import { mapOrderShowtimeSelectionsToOrderShowtime } from '../../mappers/order-showtime';
import { isStandardOrder } from '../../utils/order-type-utils';
import { getOrder } from '../order/get-order';
import { getOrderSelections } from '../order/get-order-selections';
export const getOrderShowtimes = () => {
    const order = getOrder();
    const orderShowtimes = isStandardOrder(order) ? order.showtimes : [];
    const selectedShowtime = getOrderSelections().showtime;
    if (selectedShowtime) {
        return [
            ...orderShowtimes.filter(showtime => showtime.showtimeId !== selectedShowtime.showtimeId),
            mapOrderShowtimeSelectionsToOrderShowtime(selectedShowtime)
        ];
    }
    return orderShowtimes;
};
